import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  selector: 'upsc-custom-success',
  templateUrl: './custom-success.component.html',
  styleUrls: ['./custom-success.component.scss']
})
export class CustomSuccessComponent {
constructor(
    public snackBarRef: MatSnackBarRef<CustomSuccessComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: any
  ) { }

  close() {
    this.snackBarRef.dismiss();
  }
}
